/*global _ */
export default {
  name: 're-validation',
  props: {
    value: {
      default: null
    },
    groupClass: {
      type: String,
      default: 'form-field'
    },
    groupErrorClass: {
      type: String,
      default: 'is-invalid form-group-error'
    },
    errorClass: {
      type: String,
      default: 'invalid-feedback'
    },
    validations: {
      type: Object,
      default: null
    },
    validator: {
      type: Function,
      default: null
    },
    tabindex: {
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    customErrors: {
      type: [String, Array, Object],
      default: null
    },
    v: {
      type: Object,
      default: null
    },
    vRoot: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      customErrorItems: null
    }
  },
  methods: {
    vCheck(vName, rule, ...rest) {
      if (this.v) {
        const vResult = this.v[rule]
        if (_.isBoolean(vResult)) {
          return !vResult
        }
      }
      const validator = this.validator || _.get(this.validations, 'validator')
      if (_.isFunction(validator)) {
        return validator(vName, rule, ...rest)
      }
      return null
    }
  },
  watch: {
    value: {
      handler(value) {
        this.customErrorItems = {}
        this.$emit('input', value)
      },
    },
    hasError(isError) {
      if (isError) {
        this.$emit('inputError', {name: this.vName, value: this.value})
      }
    },
    customErrors: {
      handler(value) {
        this.customErrorItems = value
      },
      immediate: true
    }
  },
  computed: {
    hasValidator() {
      return !_.isEmpty(this.validator) || !_.isEmpty(this.validations)
    },
    hasError() {
      return this.v ? this.v.$anyError :
        (this.hasValidator ? _.some(this.vItems, (i, rule) => this.vCheck(this.vName, rule)) : false)
    },
    hasCustomError() {
      return !_.isEmpty(this.allCustomErrors)
    },
    hasErrors() {
      return this.hasError || this.hasCustomError
    },
    vName() {
      return _.get(this.validations, 'name')
    },
    vItems() {
      return _.get(this.validations, 'items', {})
    },
    allCustomErrors() {
      let errors = this.customErrorItems
      if (!_.isEmpty(this.errors) && _.isString(errors)) {
        errors = [errors]
      }
      return errors
    },
  }
}
